<button
  type="button"
  class="al"
  data-if-glow
  [class.al--fixed]="fixed()"
  [attr.aria-pressed]="fixed()"
  [attr.aria-label]="accessibleName()"
  [disabled]="disabled()"
  (click)="toggle()"
>
  <span class="al-axis" aria-hidden="true">{{ axis() }}</span>
  @if (fixed()) {
    <svg class="al-icon al-icon--fixed" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
      <path stroke-linecap="round" stroke-linejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z" />
    </svg>
  } @else {
    <svg class="al-icon al-icon--free" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">
      <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 10.5V6.75a4.5 4.5 0 1 1 9 0v3.75M3.75 21.75h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H3.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z" />
    </svg>
  }
  <span class="al-state" aria-hidden="true">
    <span class="al-state__word" [class.al-state__word--shown]="fixed()">Fixed</span>
    <span class="al-state__word" [class.al-state__word--shown]="!fixed()">Free</span>
  </span>
</button>
